import { get } from 'lodash';

export const getReceipt = state => get(state, 'receipt.item', {});
export const getReceiptLoading = state => get(state, 'receipt.loading', {});
export const getShopObjectFromReceipt = state => get(state, 'receipt.item.shop');



// WEBPACK FOOTER //
// ./src/app/receipt/selectors.js